"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _default = /*#__PURE__*/function () {
  function _default() {
    (0, _classCallCheck2["default"])(this, _default);
  }

  (0, _createClass2["default"])(_default, null, [{
    key: "getUrlParams",
    value: function getUrlParams(path) {
      if (!path && (!window || !window.location || !window.location.search)) {
        return {};
      }

      var search = path || window.location.search;
      var hashes = search.slice(search.indexOf('?') + 1).split('&');
      var params = {};
      hashes.map(function (hash) {
        var _hash$split = hash.split('='),
            _hash$split2 = (0, _slicedToArray2["default"])(_hash$split, 2),
            key = _hash$split2[0],
            val = _hash$split2[1];

        params[key] = decodeURIComponent(val);
        return params;
      });
      return params;
    }
  }, {
    key: "getBasePath",
    value: function getBasePath() {
      if (!window || !window.location || !window.location.hash) {
        return '';
      }

      var urlHash = window.location.hash;

      if (urlHash) {
        var path = urlHash.substr(1, urlHash.length);

        if (path) {
          return path;
        }
      }

      return '';
    }
  }, {
    key: "parseURL",
    value: function parseURL(url) {
      var parser = document.createElement('a');
      var searchObject = {};
      parser.href = url;
      var queries = parser.search ? parser.search.replace(/^\?/, '').split('&') : [];

      for (var i = 0; i < queries.length; i++) {
        var split = queries[i].split('=');
        searchObject[split[0]] = decodeURIComponent(split[1]);
      }

      return {
        protocol: parser.protocol,
        host: parser.host,
        hostname: parser.hostname,
        port: parser.port,
        pathname: parser.pathname,
        search: parser.search,
        searchObject: searchObject,
        hash: parser.hash
      };
    }
  }]);
  return _default;
}();

exports["default"] = _default;